import { Media } from '@/models/Report';

export const reportAttachmentMap: Media[] = [
  { type: 'counseling', file_name: 'Adviesrapport', description: 'Adviesrapport', hin_show_to_all: true, sort_order: 0, original: '' },
  { type: 'decision', file_name: 'Besluit bestuur', description: 'Besluit bestuur', hin_show_to_all: true, sort_order: 0, original: '' },
  { type: 'agreement_applicant_signed', file_name: 'Getekende overeenkomst aanvrager', description: 'Getekende overeenkomst met de aanvrager', hin_show_to_all: true, sort_order: 0, original: '' },
  { type: 'agreement_contractor_signed', file_name: 'Getekende overeenkomst aannemer', description: 'Getekende overeenkomst met de aannemer', hin_show_to_all: true, sort_order: 0, original: '' },
];

export const bureauAttachmentTypes: string[] = ['counseling', 'decision', 'agreement_applicant_signed'];
export const contractorAttachmentTypes: string[] = ['agreement_contractor_signed'];
